 import packageJson from 'package.json';
 
 export const environment: any = {
    version: packageJson.version,
    VERSION: packageJson.version,
    API_ENDPOINT: 'https://wg1-api.elements-eng.cloud:28443/api/v1',
    API_URL: 'https://wg1-api.elements-eng.cloud:28443/api/v1/datastructures',
    API_STATIC_FILE_UPLOAD: 'https://eng-upload.q9elements.com:11443/api',
    APPNAME: 'HD-APP',
    ANALYSIS_API: 'https://dev-gateway.q9elements.com/automation-us-dependency-analysis/api/v1/dependency-analysis',
    CHANGELOG_APP_URL: 'https://wg1-changelogs.elements-eng.cloud',
    CLOUD_NAME: 'elements',
    CLOUD_TYPE: 'public',
    DATA_STRUCTURE_URL: 'https://wg1-datatable.elements-eng.cloud',
    DE_APP_URL: 'https://wg1-diagram.elements-eng.cloud',
    DE_APP: 'https://wg1-diagram.elements-eng.cloud',
    DIAGRAM_URL: 'https://wg1-diagram.elements-eng.cloud',
    DOMAIN: 'elements-eng.cloud',
    ENTERPRISE_URL: 'https://wg1-corp.elements-eng.cloud',
    ENV: 'wg1',
    GDPR_SUPPORT_LINK: 'https://support.elements.cloud/en/articles/1221094-enable-data-privacy-gdpr-compliance-for-a-ref-model',
    HELP_LINK: 'https://support.elements.cloud/',
    IMPORT_MAP_API: 'https://dev-gateway.q9elements.com/wg1-map-import/api/v1',
    IMPORTS_API: 'https://dev-gateway.q9elements.com/wg1-import/api/v1',
    INTERCOM_APP_ID: 'c2s7te3m',
    INTERCOM_URL: 'string',
    MAIN_APP_URL: 'https://wg1.elements-eng.cloud',
    MAIN_APP: 'https://wg1.elements-eng.cloud',
    MAP_MANAGEMENT_APP: 'https://wg1-mapmgt.elements-eng.cloud',
    NO_IMAGE_URL: '../../assets/images/no_image.png',
    NOUI: false,
    PARTNER_APP: 'https://wg1-partnermgt.elements-eng.cloud',
    PREVIEW_HOLDER: '/assets/images/map_placeholder.png',
    production: false,
    PX_KEY: 'AP-3EN4L67VSTXG-2-3',
    RAVEN_DSN: 'https://eb6892047d9b42638a7563ddb26386ea@sentry.io/1233470',
    RAVEN_ID: '9e76fe14aaba4a31846fe607572f9eb1',
    REF_MODEL_APP: 'https://wg1-refmodel.elements-eng.cloud',
    RELEASE_URL: 'https://wg1-releasemgt.elements-eng.cloud',
    REMOTE_UNLOCK_TTL: 3600000,
    REPORTS_API_ENDPOINT: 'https://dev-gateway.q9elements.com/wg1-report/api/v1',
    REPORTS_API: 'https://dev-gateway.q9elements.com/wg1-report/api/v1', 
    REPORTS_APP: 'https://wg1-report.elements-eng.cloud',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2UsdvxV2Sbjupj4KhRcZbqPuMpR2bMqU0ASTxp9N318TkE_RdNTUEpr8.u4KkkyL',
    SALESFORCE_REDIRECT_URL: 'https://wg1.elements-eng.cloud/auth/callback',
    SALESFORCE_URL_TEST: 'https://test.salesforce.com/services/oauth2/authorize',
    SALESFORCE_URL: 'https://login.salesforce.com/services/oauth2/authorize',
    SECURE_COOKIES: true,
    SYS_ADMIN_APP: 'https://wg1-sysadmin.elements-eng.cloud',
    TEAM_APP: 'https://wg1-spacemgt.elements-eng.cloud',
    TOASTR_TIMEOUT: 5000,
    UNLOCK_TTL: 180000,
    SENTRY_AUTH_TOKEN: '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',
    SENTRY_DSN: 'https://48346d8b5621b48f13689b7da3ba9d3c@o45875.ingest.us.sentry.io/4509802379935744',
    SENTRY_ORG: 'q9-elements-ltd',
    SENTRY_PROJECT: 'refmodel-test-1',
    fbConfig: {
        apiKey:'AIzaSyAxvMqbbr8lgx3dFBY150dyHq7yAjBf9Ho',
        authDomain:'elements-wg1.firebaseapp.com',
        databaseURL: 'https://elements-wg1-default-rtdb.firebaseio.com',
        projectId: 'elements-wg1',
        appId: '1:39518708173:web:325b3a55fbdf7076522484'
    }
}; 
